import errorLogger from '@/services/errorLogger'

/**
 * Vuex plugin to capture and log dispatch errors
 * This ensures all Vuex-related errors are properly logged
 */
export default function createErrorLoggingPlugin () {
  return store => {
    // Store original dispatch method
    const originalDispatch = store.dispatch

    // Override dispatch method with error handling
    store.dispatch = function (type, payload, options) {
      try {
        const result = originalDispatch.call(this, type, payload, options)

        // Handle promise-based actions
        if (result && typeof result.catch === 'function') {
          return result.catch(error => {
            // Log the dispatch error
            errorLogger.logError(error, {
              vuexAction: type,
              payload: payload,
              actionType: 'vuex-dispatch'
            }, 'vue')

            // Re-throw the error so the component can handle it
            throw error
          })
        }

        return result
      } catch (error) {
        // Log synchronous errors
        errorLogger.logError(error, {
          vuexAction: type,
          payload: payload,
          actionType: 'vuex-dispatch'
        }, 'vue')

        // Re-throw the error so the component can handle it
        throw error
      }
    }

    // Store original commit method for completeness
    const originalCommit = store.commit

    // Override commit method with error handling
    store.commit = function (type, payload, options) {
      try {
        return originalCommit.call(this, type, payload, options)
      } catch (error) {
        // Log mutation errors
        errorLogger.logError(error, {
          vuexMutation: type,
          payload: payload,
          actionType: 'vuex-commit'
        }, 'vue')

        // Re-throw the error so the component can handle it
        throw error
      }
    }
  }
}
